import { useRouter } from "next/router";
// @mui
import {
  Box,
  Stack,
  Typography,
} from "@mui/material";
import { alpha } from '@mui/material/styles';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Iconify from '../../components/Iconify';
import SvgIconStyle from '../../components/SvgIconStyle';
// routes
import { PATH_REWARD } from '../../routes/paths';

// ----------------------------------------------------------------------
export default function OfferPassRewardAlert({ openJobPost=false }) {
  const smUp = useResponsive('up', 'sm');
  const router = useRouter();

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 2.5 },
        borderRadius: 2,
        backgroundColor: (theme) => alpha(theme.palette.secondary.main, 0.08),
        ":hover": {
          backgroundColor: (theme) => alpha(theme.palette.secondary.main, 0.12),
          cursor: 'pointer'
        }
      }}
      onClick={() => {
        router.push(PATH_REWARD.root);
      }}
    >
      <Stack direction="row" alignItems="flex-start" spacing={1}>
        <SvgIconStyle src={`/icons/icon-coin-mono.svg`} sx={{ color: "secondary.main" }} />
        <Stack>
          <Typography variant={smUp ? "subtitle1" : "subtitle2"} sx={{ color: "secondary.main", mb: 0.5 }}>
            크루 초대하면 10만원 리워드!
          </Typography>
          {openJobPost ? (
          <Typography variant={smUp ? "body1" : "body2"} sx={{ color: "text.primary" }}>
            이 공고에 더 적합한 분을 알고 계신가요?
          </Typography>
          ) : (
          <Typography variant={smUp ? "body1" : "body2"} sx={{ color: "text.primary" }}>
            크루님께서는 거절하셨지만,{!smUp && <br />} 더 적합한 분을 알고 계신가요?
          </Typography>
          )}
          <Typography variant={smUp ? "body1" : "body2"} sx={{ color: "text.primary" }}>
            초대하고 리워드를 받아보세요!
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row" alignItems={"center"} justifyContent="flex-end" spacing={.5} sx={{ mt: smUp ? 0 : 0.5 }}>
        <Typography variant="subtitle2" sx={{ color: "secondary.main", cursor: 'pointer' }}>
          더 알아보기
        </Typography>
        <Iconify icon="eva:arrow-ios-forward-fill" width={20} height={20} sx={{ color: "secondary.main" }} />
      </Stack>
    </Box>
  )
};
